/**
 * The highest version in a deployed-version list, as `v<n>`.
 *
 * An EMPTY list answers `''`, not `'vundefined'`. Without that guard
 * `[].sort()[0]` is `undefined` and the template literal builds the string
 * `'vundefined'` — a TRUTHY value that every downstream guard accepts: it
 * survives `if (draftVersion)` in `load-bot-versions.ts`, `buildSolutionVersionId`
 * composes `<customer>-<bot>-vundefined` from it, and `builder.tsx` writes that
 * into `tableStore.solutionVersionId`, which is what every queued write is
 * stamped with. So the empty case used to fail SILENTLY, under an identity no
 * solution has (PSTUDIO-4121).
 */
export const findLastDeployedVersion = (deployedVersions: string[]): string => {
  if (!deployedVersions.length) {
    return '';
  }

  const lastDeployedVersion = deployedVersions
    .map((v) => v.replace('v', ''))
    .sort((a, b) => +b - +a)[0];

  return `v${lastDeployedVersion}`;
};
